module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00056.dc0a571d.png";